import { getCachedViewSnapshotForSelections } from '@databases/database-state';
import { createPublishRovoSelectionEffect } from '@databases/rovo-bridge/selections-effect';
import { getService } from '@databases/service-container';
import {
  type DatabaseLayoutType,
  isBuiltInDatabaseLayoutType,
} from '@databases/types/database/view';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

import {
  SelectionFeatureKeys,
  type SelectionEffectFeature,
} from '../../features/types.ts';

export interface PublishRovoEffectFeatureLifecycleDeps {
  currentViewType: DatabaseLayoutType | undefined;
}

export function createPublishRovoEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.PUBLISH_ROVO_EFFECT,
    type: 'effect',
    // Always active — publishing selection state to Rovo is read-only.
    factory: () => {
      const currentView = getCachedViewSnapshotForSelections();
      const layoutType = currentView.settings.layout.type;

      return createPublishRovoSelectionEffect({
        selectionsApi: getService('SelectionsApi'),
        publishSelectionToRovo: (selection: string[]) => {
          waitForContentAPI().then((contentAPI) => {
            contentAPI?.publishDatabaseReferencingContent?.(selection);
          });
        },
        currentViewType: isBuiltInDatabaseLayoutType(layoutType) ? layoutType : undefined,
      });
    },
  };
}
